module.exports = __webpack_public_path__ + "img/save_progress_success.7dedf143.png";